module.exports = __webpack_public_path__ + "img/event-atelier-ms-fevrier-2025.6b00d7e.jpg";